import { ProductListingPageLink } from './types';
import { useMemo, useRef, useState, useEffect } from 'react';
import { useFoundItData } from './data/useFoundItData';
import classNames from 'classnames';
import qs from 'qs';
import styles from './FoundIt.module.scss';
import { UnderlinedButton } from '@JohnLewisPartnership/jl-design-system/elements/button/Button';
import Carousel from '@JohnLewisPartnership/jl-design-system/components/carousel/DEPRECATED_Carousel';
import { useRouterContext } from '../../context/PlpContext';
import { dispatchFoundItAnalytics } from '../analytics/analyticsEvents';
import {
  foundItFilter,
  getQueryParams,
  getQueryString,
} from '../stateful-link/StatefulLink';

export const FoundIt = () => {
  const router = useRouterContext();
  const { foundItLinks } = useFoundItData();
  const foundItLinksToDisplay = foundItLinks;

  const [clientSideReady, setClientSideReady] = useState(false);

  const imageLimit = 12;

  const carouselRef = useRef();

  useEffect(() => {
    setClientSideReady(true);
  }, []);

  const onwardLinks: ProductListingPageLink[] = useMemo(() => {
    return (
      foundItLinksToDisplay
        ?.sort((a, b) => {
          return a.Order - b.Order;
        })
        .slice(0, imageLimit) || []
    );
  }, [foundItLinksToDisplay]);

  if (!foundItLinksToDisplay || foundItLinksToDisplay.length === 0) {
    return null;
  }

  const onFoundItClick = (evt, link) => {
    evt.preventDefault();

    const foundItAnalyticsLink = `${window.location.pathname}|${router.query.type}|main-links|${link.Order}|${onwardLinks.length}|${link.AnchorText}|${link.DestinationUrl}`;
    dispatchFoundItAnalytics(foundItAnalyticsLink);

    const targetUrl = new URL(link.DestinationUrl);

    let query = { ...router.query, fi: 'c' };

    // append any existing query params from the DestinationUrl
    if (targetUrl.search) {
      const targetSearchParams = qs.parse(targetUrl.search, {
        ignoreQueryPrefix: true,
      });
      if (targetSearchParams) {
        query = { ...targetSearchParams, ...query };
      }
    }

    const validatedQuery = getQueryParams(query, foundItFilter());

    const newUrl = {
      pathname: `${targetUrl.pathname}`,
      query: validatedQuery,
    };

    const newAs = `${targetUrl.pathname}?${getQueryString(validatedQuery)}`;

    router.push(newUrl, newAs);
  };

  return (
    <Carousel
      ref={carouselRef}
      className={styles.onwardLinks}
      data-test="found-it-carousel"
      dots={false}
      largeChevrons
    >
      {onwardLinks.map((link, i) => (
        <li
          key={i}
          className={classNames(styles.onwardLink, {
            [styles.firstOnwardLink]: i === 0,
            [styles.lastOnwardLink]: i === onwardLinks.length - 1,
          })}
        >
          <UnderlinedButton
            data-testid="foundit-underlined-button"
            className={styles.externalButton}
            tag="a"
            rel="noreferrer"
            href={link.DestinationUrl}
            onClick={
              clientSideReady ? (evt) => onFoundItClick(evt, link) : null
            }
          >
            {link.ImageUrl && <img src={link.ImageUrl} alt={link.AnchorText} />}
            <span>{link.AnchorText}</span>
          </UnderlinedButton>
        </li>
      ))}
    </Carousel>
  );
};
